import React from "react";
import Style from "./index.module.scss";
import Ioitem from "./Components/Ioitem";
import { TopicsItem } from "../../../../Service";

interface Props {
    item: TopicsItem;
    onSave: (value: any) => void;
    disabled: boolean;
}
const Index = ({ item, onSave, disabled, ...restProps }: Props) => {
    return (
        <div>
            <h1 className={Style.title}>
                {item.index} - {item.typeName}
            </h1>
            <div className={Style.content}>
                <h2 className={Style.contentText}>{item.contentText}</h2>
                <Ioitem
                    {...restProps}
                    disabled={disabled}
                    queTypeId={item.queTypeId}
                    onSave={onSave}
                    options={item.options}
                />
            </div>
        </div>
    );
};

export default Index;
